import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

import { EventAttendingBadge } from "./event-attending-badge";
import { EventCategoryBadge } from "./event-category-badge";

type EventThumbnailProps = {
  className?: string;
  category?: string;
  isAttending?: boolean;
  bannerImageUrl?: string;
  isLessThen5SpotsLeft?: boolean;
  isEventFull?: boolean;
};

export function EventThumbnail({
  className,
  category,
  isAttending,
  bannerImageUrl,
  isLessThen5SpotsLeft,
  isEventFull,
}: EventThumbnailProps) {
  return (
    <div
      className={cn(
        "relative m-1 overflow-hidden rounded-xl border-border bg-gray-200 bg-right-bottom bg-no-repeat p-4 text-center",
        className,
      )}
    >
      {category && (
        <div className="absolute left-2 top-2 z-10">
          <EventCategoryBadge category={category} />
        </div>
      )}
      {bannerImageUrl && (
        <img
          src={bannerImageUrl}
          alt={""}
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 group-hover:scale-125"
        />
      )}
      <div className="absolute right-2 top-2 z-10 flex items-center gap-2">
        {!isEventFull && isLessThen5SpotsLeft && (
          <Badge variant="outline" className="absolute left-2 top-2 z-10">
            <span className="text-muted-foreground">Limited seats left</span>
          </Badge>
        )}
        {isEventFull && (
          <Badge variant="outline">
            <span className="text-muted-foreground">Fully Booked</span>
          </Badge>
        )}
        {isAttending && <EventAttendingBadge />}
      </div>
      <div className="relative z-10 flex h-full flex-col"></div>
    </div>
  );
}
